import React from 'react'

import { Stack, Typography } from '@mui/material'

import { InfoButton } from '../InfoButton'

type WidgetTitlePropTypes = {
  children: string
  explanation?: string | null
}

export const WidgetTitle: React.FC<WidgetTitlePropTypes> = ({ children, explanation }) => {
  return (
    <Stack direction={'row'} spacing={1} alignItems={'flex-start'}>
      <Typography variant="h4" color="text.secondary">
        {children}
      </Typography>

      {Boolean(explanation) && <InfoButton explanation={explanation} />}
    </Stack>
  )
}

export default WidgetTitle
